import React from 'react';
import { Container, Row, Col, Image } from 'react-bootstrap';

// img
import AboutImg from '../../images/about-img.png';
import SectionTitle from '../ui/SectionTitle';
import ImgHoverEffect from '../ui/ImgHoverEffect';
import { motion } from 'framer-motion';

export default function About() {
    return (
        <>
            <motion.section  className='sectio about-section' id='about' initial={{opacity: 0, y: 50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}>
                <Container>
                    <Row className='justify-content-center'>
                        <Col md={6} className='section-title text-center mb-5'>
                            <SectionTitle title="About Us"/>
                        </Col>
                    </Row>

                    <Row className='align-items-center'>
                        <Col lg={7} xl={6}>
                            <ImgHoverEffect className="d-inline-block" intensity={20} scale={1.05}>
                                <Image src={AboutImg} alt="" className='img-fluid about-img-shadow img-hover' />
                            </ImgHoverEffect>
                        </Col>
                        <Col lg={5} xl={6} xxl={5} className='offset-xxl-1 mt-lg-0 mt-5'>
                            <motion.h1 className='display-5 fw-semibold' initial={{opacity: 0, y: 50}} whileInView={{opacity: 1, y: 0}} transition={{duration: 0.5}}>Choosing Healthy & Fresh Food
                                <span className='svg-text-danger ms-2 d-inline-block'>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="50" viewBox="0 0 24 24"><title>emoticon-tongue-outline</title><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20M9,10C8.26,10 7.61,10.4 7.27,11C7.1,10.71 7,10.36 7,10A2,2 0 0,1 9,8C10.11,8 11,8.9 11,10C11,10.36 10.9,10.71 10.73,11C10.39,10.4 9.74,10 9,10M17,10C17,10.36 16.9,10.71 16.73,11C16.39,10.4 15.74,10 15,10C14.26,10 13.61,10.4 13.27,11C13.1,10.71 13,10.36 13,10A2,2 0 0,1 15,8C16.11,8 17,8.9 17,10M16,13V15H15C15,17 14.1,18 13,18C11.9,18 11,17 11,15H8V13H16Z" /></svg>
                                </span>
                            </motion.h1>
                            <motion.p className='text-muted mb-4 pb-2' initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>At Reshto, we prioritize the healthiest and freshest ingredients to ensure every bite is both delicious and nourishing. Our dedication to quality forms the foundation of a great dining experience.</motion.p>
                            <motion.div className="d-flex mb-2" initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                                <div className="flex-shrink-0">
                                    <div className='avatar avatar-lg bg-soft-danger text-danger rounded-3'>
                                        <i className="ri-shopping-cart-line"></i>
                                    </div>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h5 className='mb-2 fs-22'>Easy to Order</h5>
                                    <p className='text-muted'>Ordering from Reshto is a breeze with our user-friendly online platform and responsive customer service.</p>
                                </div>
                            </motion.div>
                            <motion.div className="d-flex mb-2" initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                                <div className="flex-shrink-0">
                                    <div className='avatar avatar-lg bg-soft-danger text-danger rounded-3'>
                                        <i className="ri-restaurant-line"></i>
                                    </div>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h5 className='mb-2 fs-22'>Delicious Taste</h5>
                                    <p className='text-muted'>Savor the exceptional flavors crafted by our skilled chefs using the freshest ingredients and unique recipes.</p>
                                </div>
                            </motion.div>
                            <motion.div className="d-flex" initial={{opacity: 0}} whileInView={{opacity: 1}} transition={{duration: 0.5}}>
                                <div className="flex-shrink-0">
                                    <div className='avatar avatar-lg bg-soft-danger text-danger rounded-3'>
                                        <i className="ri-e-bike-2-line"></i>
                                    </div>
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <h5 className='mb-2 fs-22'>Fastest Delivery</h5>
                                    <p className='text-muted mb-0'>Enjoy our speedy delivery service that ensures your meal arrives hot and fresh, right to your doorstep.</p>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </motion.section>
        </>
    )
}
